import { buildBettoAlertPayload } from "./bettoAlertConfig";
import { BETTO_ALERT_VARIANTS } from "./bettoAlertVariants";

const completeBettoSignup = () => {
	if (window.SIGNUP_AFTER_REDIRECTION) {
		window.location.href = window.SIGNUP_AFTER_REDIRECTION;
		return;
	}

	window.location.reload();
};

const VARIANT_SIDE_EFFECTS = {
	"welcome-platform": {
		runCompleteOnClose: true,
		completeCallback: completeBettoSignup,
	},
};

export const showBettoAlert = (showAlert, variant, { onClose, ...options } = {}) => {
	if (window.TENANT !== "betto" || !BETTO_ALERT_VARIANTS[variant]) {
		return false;
	}

	onClose?.();

	const payload = buildBettoAlertPayload(variant, {
		...VARIANT_SIDE_EFFECTS[variant],
		...options,
	});

	showAlert(payload);

	return true;
};
